import React from 'react';

const Pitch3d = props => {
    return (
        <svg
            className="sm-pitch"
            preserveAspectRatio={props.stretch ? 'none' : 'xMinYMin'}
            viewBox={props.viewBox || '0 0 656 520'}
            height={props.height}
            width={props.width}
            style={{ overflow: 'visible' }}
        >
            <g transform="translate(20, 0)">
                <defs>
                    <radialGradient
                        cx="50%"
                        cy="52.7604928%"
                        fx="50%"
                        fy="52.7604928%"
                        r="55.7519317%"
                        gradientTransform="translate(0.500000,0.527605),scale(0.759740,1.000000),rotate(90.000000),translate(-0.500000,-0.527605)"
                        id="radialGradient-1"
                    >
                        <stop stopColor={props.stopColor0 || '#389E38'} offset="0%" />
                        <stop stopColor={props.stopColor100 || '#287E36'} offset="100%" />
                    </radialGradient>
                    <filter
                        x="-10.7%"
                        y="-7.7%"
                        width="121.4%"
                        height="128.2%"
                        filterUnits="objectBoundingBox"
                        id="filter-3"
                    >
                        <feOffset dx="0" dy="24" in="SourceAlpha" result="shadowOffsetOuter1" />
                        <feGaussianBlur stdDeviation="10" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
                        <feColorMatrix
                            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"
                            type="matrix"
                            in="shadowBlurOuter1"
                            result="shadowMatrixOuter1"
                        />
                        <feOffset dx="0" dy="6" in="SourceAlpha" result="shadowOffsetOuter2" />
                        <feGaussianBlur stdDeviation="4.5" in="shadowOffsetOuter2" result="shadowBlurOuter2" />
                        <feGaussianBlur stdDeviation="4.5" in="shadowMatrixOuter2" result="shadowBlurOuter2" />
                        <feColorMatrix
                            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.7 0"
                            type="matrix"
                            in="shadowBlurOuter2"
                            result="shadowMatrixOuter2"
                        />
                        <feMerge>
                            <feMergeNode in="shadowMatrixOuter1" />
                            <feMergeNode in="shadowMatrixOuter2" />
                        </feMerge>
                    </filter>
                </defs>
                <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="statium_export">
                        <g id="Pitch">
                            <use fill="black" fillOpacity="1" filter="url(#filter-3)" xlinkHref="#path-2" />
                            <use fill="url(#radialGradient-1)" fillRule="evenodd" xlinkHref="#path-2" />
                            <polygon
                                fill={props.background || '#2A8337'}
                                id="path-2"
                                points="62.154806 0 553.845194 0 616 468 0 468"
                            />
                        </g>
                        <rect
                            id="Rectangle-3"
                            fill={props.bottomBorder || '#1C2806'}
                            x="-4.54747351e-13"
                            y="468"
                            width="616"
                            height="10"
                        />
                        <g
                            id="stripes"
                            transform="translate(3.000000, 0.000000)"
                            fill={props.stripes || '#fff'}
                            opacity="0.03"
                        >
                            <polygon
                                id="Rectangle-2"
                                points="58.838278 0 550.161722 0 552.853281 21.3333333 56.146719 21.3333333"
                            />
                            <polygon
                                id="Rectangle-2"
                                points="52.455159 42.6666667 556.544841 42.666667 559.2364 64 50.7636 64"
                            />
                            <polygon
                                id="Rectangle-2"
                                points="47.072041 85.3333333 561.927959 85.3333333 565.619519 106.666667 44.380481 106.666667"
                            />
                            <polygon
                                id="Rectangle-2"
                                points="42.688922 128 567.311078 128 571.002637 149.333333 38.997363 149.333333"
                            />
                            <polygon
                                id="Rectangle-2"
                                points="35.305803 170.666667 573.694197 170.666667 576.385756 192 32.614244 192"
                            />
                            <polygon
                                id="Rectangle-2"
                                points="29.922685 213.333333 580.077315 213.333333 581.768875 234.666667 27.2311254 234.666667"
                            />
                            <polygon
                                id="Rectangle-2"
                                points="23.539566 256 585.460434 256 589.151993 277.333333 22.8480067 277.333333"
                            />
                            <polygon
                                id="Rectangle-2"
                                points="18.156447 298.666667 591.843553 298.666667 594.535112 320 16.4648881 320"
                            />
                            <polygon
                                id="Rectangle-2"
                                points="11.773329 341.333333 597.226671 341.333333 598.918231 362.666667 10.0817694 362.666667"
                            />
                            <polygon
                                id="Rectangle-2"
                                points="7.3902101 384 602.60979 384 604.301349 405.333333 4.69865073 405.333333"
                            />
                            <polygon
                                id="Rectangle-2"
                                points="3.007091 426.666667 606.992909 426.666667 608.684468 448 0.315532052 448"
                            />
                        </g>
                        <path
                            d="M307.998675,52.7368421 C291.698491,52.7368421 276.790481,49.9347031 267.439948,45.2674361 L267.454135,45 L264.039415,45 L264,45.6853817 L264.32496,45.8526904 C274.271938,50.9380455 290.371873,54 307.998673,54 C325.627149,54 341.728421,50.9374594 351.675127,45.8512936 L352,45.6839986 L351.960664,45 L348.545944,45 L348.560059,45.2661148 C339.209747,49.9341505 324.300455,52.7368421 307.998675,52.7368421 Z"
                            id="Oval-2"
                            fill={props.lines || '#8AD58A'}
                            fillRule="nonzero"
                        />
                        <path
                            d="M308.001646,381.245614 C327.661224,381.245614 345.891895,386.227195 357.791344,394.524558 L357.805454,395 L362,395 L361.960786,393.781544 L361.541052,393.484106 C348.85265,384.443475 329.197884,379 308.001644,379 C286.803388,379 267.146955,384.444517 254.458761,393.486589 L254.039135,393.784003 L254,395 L258.194546,395 L258.208589,394.526907 C270.107876,386.228177 288.340143,381.245614 308.001646,381.245614 Z"
                            id="Oval-2"
                            fill={props.lines || '#8AD58A'}
                            fillRule="nonzero"
                        />
                        <polygon
                            id="Path"
                            fill={props.lines || '#8AD58A'}
                            fillRule="nonzero"
                            points="57.367181 198 560.633071 200 561 203 56 201"
                        />
                        <polygon
                            id="Path"
                            fill={props.lines || '#8AD58A'}
                            fillRule="nonzero"
                            points="167.189221 397.303666 162.333333 457 158 457 163.193821 395 451.806179 395 457 457 452.666667 457 447.810779 397.303666"
                        />
                        <polygon
                            id="Path"
                            fill={props.lines || '#8AD58A'}
                            fillRule="nonzero"
                            points="245.092012 436.3 244.349209 457 240 457 240.881291 434 376.118804 434 377 456.997531 372.650797 456.997531 371.908083 436.3"
                        />
                        <polygon
                            id="Path"
                            fill={props.lines || '#8AD58A'}
                            fillRule="nonzero"
                            points="194.578855 43.6995433 199.438964 10 196.198336 10 191 45 425 45 419.801664 10 416.561036 10 421.421145 43.6995433"
                        />
                        <polygon
                            id="Path"
                            fill={props.lines || '#8AD58A'}
                            fillRule="nonzero"
                            points="259.384019 21.7 260.125909 10 256.880208 10 256 23 360 23 359.119887 10.0013958 355.874179 10.0013958 356.615981 21.7"
                        />
                        <path
                            d="M22.719732,455.732997 L81.967293,10.2670025 L535.032707,10.2670025 L594.280268,455.732997 L22.719732,455.732997 Z M18,458 L599,458 L537.907088,8 L79.092911,8 L18,458 Z"
                            id="Rectangle"
                            fill={props.lines || '#8AD58A'}
                            fillRule="nonzero"
                        />
                        <path
                            d="M308,161 C273.542791,161 244.897818,178.237037 244.019663,199.5 C243.141508,220.762963 271.786481,238 308,238 C344.213519,238 372.858492,220.762963 371.980337,199.5 C371.102182,178.237037 342.457209,161 308,161 Z M308,163.333333 C340.41889,163.333333 367.327803,179.525702 368.102741,199.5 C368.877678,219.474298 341.968765,235.666667 308,235.666667 C274.031235,235.666667 247.122322,219.474298 247.897259,199.5 C248.672197,179.525702 275.58111,163.333333 308,163.333333 Z"
                            id="Combined-Shape"
                            fill={props.lines || '#8AD58A'}
                            fillRule="nonzero"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
};
export default Pitch3d;

const Pitch2d = props => {
    return (
        <svg
            className="sm-pitch"
            preserveAspectRatio={props.stretch ? 'none' : 'xMinYMin'}
            viewBox={props.viewBox || '0 0 627 682'}
            fill={props.background || '#2A8337'}
            stroke={'#fff'}
            style={{ overflow: 'visible', minHeight: props.minHeight }}
        >
            <g id="Bg">
                <rect y="0" width="626" height="682" stroke="transparent" />
            </g>
            <g id="Lines" className="st0">
                <polyline className="st1" points="17,682 17,16 609.4,16 609.4,682 	" />
                <path
                    className="st1"
                    d="M313.2,602.3c-41.8,0-75.7-34-75.7-75.8s34-75.7,75.8-75.7c41.8,0,75.7,33.9,75.7,75.8
		C389,568.4,355.1,602.3,313.2,602.3C313.2,602.3,313.2,602.3,313.2,602.3z"
                />
                <path className="st1" d="M372.5,143.7c-26.1,32.7-73.7,38.2-106.5,12.1c-4.5-3.6-8.5-7.6-12.1-12.1" />
                <line className="st1" x1="609.4" y1="525.4" x2="17" y2="525.4" />
                <rect x="155.7" y="16" className="st1" width="315" height="127.7" />
                <rect x="242.8" y="16" className="st1" width="142" height="41.8" />
            </g>
        </svg>
    );
};
export { Pitch3d, Pitch2d };



/** WEBPACK FOOTER **
 ** ../src/widgets/components/ui/svg/pitch.js
 **/